import { GNS } from '../core/GNS.js';

/**
 * GNS.AbstractScene
 * * すべてのシーン（ページ）クラスの基底クラス
 * * 責務:
 * - ページの表示・非表示アニメーション (show/hide)
 * - 内部リンクのSPA遷移への書き換え (hijack internal links)
 * - 共通の状態管理 (isShow, isLoaded)
 */
GNS.AbstractScene = function (GNS) {
    // DisplayObjectを継承
    const scene = GNS.create(GNS.DisplayObject);

    /**
     * 初期化処理
     */
    scene.init = function (selector) {
        scene._super.init.call(this, selector);

        this.isShow = false;
        this.isLoaded = false;

        // 初期状態は非表示（透明）
        TweenMax.set(this.element, { alpha: 0 });

        // 初期DOM内のリンクをSPA遷移に対応させる
        this.addSceneEventIn(this.element);
    };

    /**
     * 指定要素内のリンクをSPA遷移（SceneController経由）に書き換える
     * @param {HTMLElement} container - 探索対象のコンテナ
     */
    scene.addSceneEventIn = function (container) {
        if (!container) return;

        const anchors = container.getElementsByTagName("a"); // 大文字小文字問わず取得
        const currentHost = window.location.host;
        const targetHosts = ["dof.jp", currentHost]; // SPA対象とするホスト

        Array.from(anchors).forEach(anchor => {
            const href = anchor.href;
            const target = anchor.getAttribute("target");

            // 除外条件:
            // 1. target="_blank" の場合
            // 2. mailto: や tel: の場合
            // 3. リンク先がない場合
            if (!href || (target && target === "_blank") || href.includes("mailto:") || href.includes("tel:")) {
                return;
            }

            // SPA対象判定:
            // 現在のホスト、または指定ドメイン(dof.jp)を含む場合
            const isInternal = targetHosts.some(host => href.includes(host));

            if (isInternal) {
                // クリックイベントを上書き
                GNS.DOM.addEvent(anchor, "click", (e) => {
                    // デフォルトの画面遷移をキャンセル
                    if (e.preventDefault) {
                        e.preventDefault();
                    } else {
                        e.returnValue = false;
                    }

                    // SceneController経由で遷移を実行
                    GNS.SceneController.gotoSceneAt(href);
                });
            }
        });
    };

    // 静的メソッドとしても公開（外部からユーティリティとして使えるように）
    scene._static.addSceneEventIn = scene.addSceneEventIn;

    /**
     * データロード処理
     * （サブクラスでオーバーライドしてAPI通信などを行う）
     */
    scene.load = function () {
        // 基底クラスでは即座に完了イベントを発火
        this.dispatchEvent(new GNS.Event(GNS.Event.LOAD));
    };

    /**
     * シーン表示処理
     * @param {Object} params - 遷移パラメータ
     */
    scene.show = function (params) {
        if (!this.isShow) {
            this.isShow = true;

            // ローディング非表示 & フッター表示
            GNS.PageLoading.getInstance().hide();
            GNS.Footer.getInstance().show();

            // クラス付与
            this.addClass("show");

            // サブクラスごとの表示ハンドラ実行
            this.showHandler(params);

            // フェードインアニメーション
            TweenMax.killTweensOf(this.element);
            TweenMax.set(this.element, { alpha: 0, y: 0 }); // y位置もリセット
            TweenMax.to(this.element, 1, {
                alpha: 1,
                ease: Power1.easeOut
            });
        }
    };

    /**
     * 表示時のフックメソッド（サブクラスで実装）
     */
    scene.showHandler = function (params) { };

    /**
     * シーン非表示処理
     */
    scene.hide = function (params) {
        if (this.isShow) {
            this.isShow = false;

            GNS.Footer.getInstance().hide();

            // サブクラスごとの非表示ハンドラ実行
            this.hideHandler(params);

            // フェードアウトアニメーション（下に下がりながら消える）
            TweenMax.killTweensOf(this.element);
            TweenMax.to(this.element, 0.5, {
                y: 50,
                alpha: 0,
                ease: Cubic.easeInOut,
                onComplete: () => {
                    this.removeClass("show");
                    this.dispatchEvent(new GNS.Event(GNS.Event.COMPLETE));
                }
            });
        }
    };

    /**
     * 非表示時のフックメソッド（サブクラスで実装）
     */
    scene.hideHandler = function (params) { };

    /**
     * リセット処理
     */
    scene.reset = function (params) {
        this.resetHandler(params);
    };

    /**
     * リセット時のフックメソッド（サブクラスで実装）
     */
    scene.resetHandler = function (params) { };

    /**
     * 画像プリロードリストへの追加（オプション機能）
     * ※現状のロジックではあまり使われていないようですが、機能として維持
     */
    scene.addLoadList = function (element) {
        if (!element) return;

        if (!this.checkItems) {
            this.checkItems = [];
        }

        this.checkItems.push({
            target: element,
            images: element.getElementsByTagName ? Array.from(element.getElementsByTagName("img")) : [],
            loaded: true // 初期値がtrue? ロジック要確認
        });
    };

    return scene._self;
}(GNS);
